const appConfig: { version: string; appName: string } = {
  version: "1.0.2",
  appName: "Assembly Storage"
};

export default appConfig;
